// extracted by mini-css-extract-plugin
module.exports = {"logo":"YouRock_logo__3Q5s8","close":"YouRock_close__1hN0w"};